<template>
  <div class="page-content-wrapper">
    <div class="page-content hello">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">test</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->
    <div>
      <div class="sel">
        <select>
          <option>Select dropdown</option>
          <option>With options</option>
        </select>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from '../mixins'
export default {
  mixins: mixins,
  name: 'about',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    changeName () {
      // let les = [1,2,3,4,5,6,7,8,9]
      this.$store.dispatch('changeName')
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .sel:not(.is-multiple) {
    height: 2.5em;
    }
    .sel {
        display: inline-block;
        max-width: 100%;
        position: relative;
        vertical-align: top;
    }
  .sel:after {
    border: 3px solid transparent;
    border-radius: 2px;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.625em;
    margin-top: -0.4375em;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: rotate(-45deg);
    transform-origin: center;
    width: 0.625em;
    border-color: #3273dc;
    right: 1.125em;
    z-index: 4;
  }
  .sel select{
    -moz-appearance: none;
    -webkit-appearance: none;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: none;
    display: inline-flex;
    font-size: 1rem;
    height: 2.5em;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.5em - 1px);
    padding-left: calc(0.75em - 1px);
    padding-right: calc(0.75em - 1px);
    padding-top: calc(0.5em - 1px);
    position: relative;
    vertical-align: top;
  }
  .sel select {
    background-color: white;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    width: 200px;
  }
  .sel select::-moz-placeholder {
    color: rgba(54, 54, 54, 0.3);
  }
  .sel fieldset[disabled] select {
    background-color: whitesmoke;
    border-color: whitesmoke;
    box-shadow: none;
    color: #7a7a7a;
  }
  .hello {
    background-color: #fff;
  }
  p {
    padding: 10px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// TestBulma.vue?0d2b2358